import { render, staticRenderFns } from "./SysPermission.vue?vue&type=template&id=6b1cb99b&scoped=true"
import script from "./SysPermission.vue?vue&type=script&lang=js"
export * from "./SysPermission.vue?vue&type=script&lang=js"
import style0 from "./SysPermission.vue?vue&type=style&index=0&id=6b1cb99b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1cb99b",
  null
  
)

export default component.exports